import axios from "axios";
import {
  API_URL,
  GYPSYBALL_PYTHON_API_URL,
  LOGINAPP_API_URL,
  GYPSYBALL_PYTHON_API_TOKEN,
} from "configs";
import { constructFrom } from "date-fns";
import { isEmpty } from "lodash";
import { use } from "react";
import { useDispatch } from "react-redux";
import { trimAndLimit } from "utils/general";
import { v4 as uuidv4 } from "uuid";
export const WORKSPACE_ADMIN_REQUEST = "WORKSPACE_ADMIN_REQUEST";
export const WORKSPACE_ADMIN_SUCCESS = "WORKSPACE_ADMIN_SUCCESS";
export const ADMIN_USER_ACCESS = "ADMIN_USER_ACCESS";
export const WORKSPACE_ADMIN_VALIDATION_ERROR = "WORKSPACE_ADMIN_VALIDATION_ERROR";
const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_WORKSPACE_ADMIN_FEILD_VALIDATION_ERROR =
  "HIDE_WORKSPACE_ADMIN_FEILD_VALIDATION_ERROR";
export const REDIRECT_TO_WORKSPACE_ADMIN_LIST = "REDIRECT_TO_WORKSPACE_ADMIN_LIST";
export const REDIRECT_TO_WORKSPACE_ADMIN_CONFIGURATION_LIST =
  "REDIRECT_TO_WORKSPACE_ADMIN_CONFIGURATION_LIST";
export const WORKSPACE_ADMIN_GET_SUCCESS = "WORKSPACE_ADMIN_GET_SUCCESS";
export const WORKSPACE_ADMIN_DROPDOWN_LIST_SUCCESS =
  "WORKSPACE_ADMIN_DROPDOWN_LIST_SUCCESS";
export const WORKSPACE_ADMIN_SERVER_SUCCESS = "WORKSPACE_ADMIN_SERVER_SUCCESS";
export const WORKSPACE_ADMIN_CHAT_GET_LLM_MODEL_SUCCESS = "WORKSPACE_ADMIN_CHAT_GET_LLM_MODEL_SUCCESS";
export const WORKSPACE_ADMIN_CHAT_GET_LLM_PROMPTS_SUCCESS = "WORKSPACE_ADMIN_CHAT_GET_LLM_PROMPTS_SUCCESS";
export const WORKSPACE_ADMIN_CHAT_GET_MODELS_VOICES_SUCCESS = " WORKSPACE_ADMIN_CHAT_GET_MODELS_VOICES_SUCCESS";
export const WORKSPACE_ADMIN_CHAT_GET_CONFIG_SUCCESS = "WORKSPACE_ADMIN_CHAT_GET_CONFIG_SUCCESS";
export const WORKSPACE_ADMIN_LIST_SUCCESS_FOR_CHAT =
  "WORKSPACE_ADMIN_LIST_SUCCESS_FOR_CHAT";
export const WORKSPACE_ADMIN_CHAT_GET_ATTACHMENT_SUCCESS = "WORKSPACE_ADMIN_CHAT_GET_ATTACHMENT_SUCCESS ";
// export const CHAT_GET_PERSONA_SUCCESS ='CHAT_GET_PERSONA_SUCCESS';
// export const CHAT_GET_INSTRUCTIONS_SUCCESS ='CHAT_GET_INSTRUCTIONS_SUCCESS';

const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";

//attachment consts
export const WORKSPACE_ADMIN_ATTACHMENT_VALIDATION_ERROR =
  "WORKSPACE_ADMIN_ATTACHMENT_VALIDATION_ERROR";
export const WORKSPACE_ADMIN_ATTACHMENT_SUCCESS = "WORKSPACE_ADMIN_ATTACHMENT_SUCCESS";

const showCommonLoader = (label = "") => ({
  type: SHOW_LOADER,
  common_loder_label: label,
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
});

const workspaceAdminRequest = () => ({
  type: WORKSPACE_ADMIN_REQUEST,
});

const getDesc = (val) => {
  let desc = trimAndLimit(val, 65355);
  return desc !== "null" && desc !== null ? desc : "";
};

export const workspaceAdminServerListSuccess = () => ({
  type: WORKSPACE_ADMIN_SERVER_SUCCESS,
});

const wworkspaceAdminListSuccess = (workspaceAdminList) => ({
  type: WORKSPACE_ADMIN_SUCCESS,
  workspaceAdminList: workspaceAdminList,
});

const getUSerSuccess = (getUser) => ({
  type: ADMIN_USER_ACCESS,
  getUser: getUser,
});

export const workspaceAdminFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});

const validationError = (notification) => ({
  type: WORKSPACE_ADMIN_VALIDATION_ERROR,
  validation_error: notification,
});
const tokenError = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "token_expire",
});

const workspaceConfigurationSuccess = (message, action, dispatch) => {
  dispatch(WorkspaceConfigurationSuccessNotification(message));
  dispatch(redirectToAdminWorkspaceConfigurationList());
};

export const redirectToAdminWorkspaceConfigurationList = () => ({
  type: REDIRECT_TO_WORKSPACE_ADMIN_CONFIGURATION_LIST,
});

const workspaceAdminAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(workspaceAdminSuccessNotification(message));
  dispatch(redirectToWorkspaceAdminList());
};

const chatAttachmentSuccess = (message, dispatch) => {
  dispatch(chatAttachmentSuccessNotification(message));
};

export const redirectToWorkspaceAdminList = () => ({
  type: REDIRECT_TO_WORKSPACE_ADMIN_LIST,
});

const getWorkspaceSuccess = (response, action) => ({
  type: WORKSPACE_ADMIN_GET_SUCCESS,
  record: response,
  actionType: action,
});

const chatAttachmentSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

const fileAttachmentSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

const workspaceAdminSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});
const WorkspaceConfigurationSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

export const hideWorkspaceAdminValidationError = (feild_key) => ({
  type: HIDE_WORKSPACE_ADMIN_FEILD_VALIDATION_ERROR,
  feild_key: feild_key,
});

const workspaceAdminListSuccessForChat = (workspaceAdminListForChat) => ({
  type: WORKSPACE_ADMIN_LIST_SUCCESS_FOR_CHAT,
  workspaceAdminListForChat: workspaceAdminListForChat,
});

export const workspaceAdminListFetchForChat = (user_id, object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        user_id: user_id,
        object_viewed_id: object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(workspaceAdminListSuccessForChat(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const workspaceAdminListFetch = (user_id, object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        user_id: user_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(wworkspaceAdminListSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const userAdminFetch = (object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "user/getAll", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      // params: { object_viewed_id: object_viewed_id }
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getUSerSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const addAdminWorkspace = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/create", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        workspaceAdminAddUpadteSuccess(
          "Workspace Added Successfully",
          "create",
          dispatch
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        // dispatch(workspaceAdminFailure("The name has already been taken"))
      }
    );
  };
};

export const updateAdminWorkspace = (data, old_name, new_name) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + "workspaceAdmin/update/" + data.get("id"), {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: data,
      });

      workspaceAdminAddUpadteSuccess(
        "Workspace Updated Successfully",
        "update",
        dispatch
      );

      // axios(GYPSYBALL_PYTHON_API_URL + 'update/workspace', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     Accept: 'application/json',
      //   },
      //   data: {
      //     old_name,
      //     new_name,
      //   },
      // });
    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};

export const getAdminWorkspaceById = (id, action) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/getById/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getWorkspaceSuccess(response.data, action));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const deleteAdminWorkspace = (
  workspaceId,
  object_viewed_id,
  user_id,
  workspace
) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());

    return axios(API_URL + "workspaceAdmin/delete/" + workspaceId, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceAdminSuccessNotification("Workspace deleted successfully")
        );

        axios(GYPSYBALL_PYTHON_API_URL + "delete/workspace", {
          method: "POST",
          withCredentials: false,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },

          data: {
            workspace,
          },
        });

        axios(GYPSYBALL_PYTHON_API_URL + "delete/chathistory", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          // withCredentials: false,
          data: {
            user_id,
            workspace,
          },
        });
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

/*
 * Workspace dropdown list fetch methods
 */
const workspaceAdminDropdownListSuccess = (workspaceAdminDropdownList) => ({
  type: WORKSPACE_ADMIN_DROPDOWN_LIST_SUCCESS,
  workspaceAdminDropdownList: workspaceAdminDropdownList,
});

export const workspaceAdminDropdownListFetch = (user_id, object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/getAllForDropdown", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        object_viewed_id: object_viewed_id,
        user_id: user_id,
      },
    }).then(
      (response) => {
        dispatch(workspaceAdminDropdownListSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      }
    );
  };
};

/*
 * attachment  methods
 */
export const uploadAdminWorkspaceAttachments = (data, object_viewed_id) => {
  var token = localStorage.getItem("token");
  let workspace_id = data.get("id");

  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/uploadAttachments/" + workspace_id, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceAdminSuccessNotification("Attachments Uploaded Successfully")
        );
        //dispatch(redirectToWorkspacesList())
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleAttachmentErrorResponse(error, dispatch);
      }
    );
  };
};

export const getAdminAttachmentsByWorkspaceId = (id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(showCommonLoader());
    dispatch(workspaceAdminRequest());
    return axios(API_URL + "workspaceAdmin/getAttachments/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(getAttachmentSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      }
    );
  };
};

export const deleteAdminWorkspaceAttachment = (id, object_viewed_id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/deleteAttachment/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceAdminSuccessNotification("Attachment deleted successfully")
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

const getAttachmentSuccess = (response) => ({
  type: WORKSPACE_ADMIN_ATTACHMENT_SUCCESS,
  workspaceAdminAttachmentList: response,
});

const attachmentValidationError = (notification) => ({
  type: WORKSPACE_ADMIN_ATTACHMENT_VALIDATION_ERROR,
  attachment_validation_error: notification,
});

const handleAttachmentErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(attachmentValidationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceAdminFailure(err));
    }
  } catch (e) {
    dispatch(workspaceAdminFailure("Unable to perform action.Something went wrong"));
  }
};

export const updateAdminWorkspaceContext = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/updateContext", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          workspaceAdminSuccessNotification("Workspace Context Updated Successfully")
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(workspaceAdminFailure(err));
    }
  } catch (e) {
    dispatch(workspaceAdminFailure("Unable to perform action.Something went wrong"));
  }
};

export const saveAiAdminSessionResponse = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    // dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/session", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        workspaceAdminAddUpadteSuccess("", "", dispatch);
      },
      (error) => {
        // dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        // dispatch(workspaceAdminFailure("The name has already been taken"))
      }
    );
  };
};





export const uploadAdminChatAttachment = (filesData, sessionId, user_id) => {
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());

    const token = localStorage.getItem("token");

    return axios
      .post(
        `${GYPSYBALL_PYTHON_API_URL}uploadfile/session?user_id=${user_id}&session_id=${sessionId}`,
        filesData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
        }
      )
      .then((response) => {
        dispatch(hideCommonLoader());
        chatAttachmentSuccess("Documents Uploaded Successfully", dispatch);
        dispatch(getChatAttachmentSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error;
      });
  };
};

export const uploadAdminAudioAttachment = (filesData, sessionId, user_id) => {
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());

    const token = localStorage.getItem("token");

    return axios(GYPSYBALL_PYTHON_API_URL + "transcribe-audio", {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: filesData,
      method: "POST",
    })
      .then((response) => {
        dispatch(hideCommonLoader());
        chatAttachmentSuccess("Audio Uploaded Successfully", dispatch);
        dispatch(getChatAttachmentSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error;
      });
  };
};

export const sendAdimnTranscribeResponse = (data) => {
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());

    const token = localStorage.getItem("token");

    return axios(GYPSYBALL_PYTHON_API_URL + "uploadtranscript", {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: data,
      method: "POST",
    })
      .then((response) => {
        dispatch(hideCommonLoader());
        chatAttachmentSuccess("Text ingested successfully", dispatch);
        dispatch(getChatAttachmentSuccess(response.data));
        return;
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error;
      });
  };
};

const getLLMModelsSuccess = (llmList) => ({
  type: WORKSPACE_ADMIN_CHAT_GET_LLM_MODEL_SUCCESS,
  llmList: llmList,
});

const getLLMPromptsSuccess = (llmPrompts) => ({
  type: WORKSPACE_ADMIN_CHAT_GET_LLM_PROMPTS_SUCCESS,
  llmPrompts: llmPrompts,
});

const getModalVoicesSuccess = (modelVoices) => ({
  type: WORKSPACE_ADMIN_CHAT_GET_MODELS_VOICES_SUCCESS,
  modelVoices: modelVoices,
});

const getChatAttachmentSuccess = (chatAttachment) => ({
  type: WORKSPACE_ADMIN_CHAT_GET_ATTACHMENT_SUCCESS,
  chatAttachment: chatAttachment,
});

export const updateAdminWorkspaceConfiguration = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "workspaceAdmin/updateAdminWorkspaceConfiguration", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        workspaceAdminAddUpadteSuccess(
          "Workspace Configuration Done Successfully",
          "create",
          dispatch
        );
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

const getVerifyConfigSuccess = (configVerify) => ({
  type: WORKSPACE_ADMIN_CHAT_GET_CONFIG_SUCCESS,
  configVerify: configVerify,
});

export const checkApiAdminResponse = (formData, api_response, onHide) => {
  return async (dispatch) => {
    const errors = [];
    const python_api_response = api_response;
    const api_response_text = JSON.stringify(python_api_response);
    let response_flag = api_response_text.includes("false");
    let object_flag = false;

    Object.keys(python_api_response).forEach((key) => {
      if (python_api_response[key]?.status === false) {
        errors.push(python_api_response[key]?.reason);
        dispatch(workspaceAdminFailure(python_api_response[key]?.reason));
        object_flag = true;
      }
    });

    if (response_flag && !object_flag) {
      if (python_api_response.status === false)
        dispatch(workspaceAdminFailure(python_api_response.msg));
      else
        dispatch(workspaceAdminFailure("Unable to process request due to an error"));
    } else if (!(errors.length > 0)) {
      const updatedFormData = {
        ...formData,
        last_api_response: python_api_response,
      };

      await dispatch(updateAdminWorkspaceConfiguration(updatedFormData));

      // ✅ Trigger AI API call
      await dispatch(aiAdminWorkspaceConfiguration(formData));

      onHide();
    }
  };
};

export const verifyAdminWorkspaceConfig = (formData, onHide) => {
  return (dispatch) => {
    dispatch(showCommonLoader());

    return axios(GYPSYBALL_PYTHON_API_URL + "verify/verifyConfig2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: formData.verifyData,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(checkApiAdminResponse(formData, response.data, onHide));
        dispatch(getVerifyConfigSuccess(response.data.status));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const aiAdminWorkspaceConfiguration = (formData) => {
  return async (dispatch) => {
    let persona = "";
    let rules = "";
    let instructions = "";

    try {
      const verifyData = JSON.parse(formData.verifyData);
      persona = verifyData.persona || "";
      rules = verifyData.rules || "";
      instructions = verifyData.instruction || "";
    } catch (e) {
      // console.error("Error parsing verifyData:", e);
    }

    const aiPayload = {
      workspace: formData.workspaceLabel,
      llm: formData.llm_model,
      k_value: formData.allowed_excel_rows,
      persona,
      rules,
      instructions,
    };

    dispatch(showCommonLoader());

    try {
      const response = await axios({
        method: "POST",
        url: GYPSYBALL_PYTHON_API_URL + "workspace-config",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
        },
        data: aiPayload,
      });

      // console.log(`API Status Code: ${response.status}`);
      // console.log('API Response Data:', response.data);

      if (response.status === 200) {
        // console.log('✅ Successful response (200 OK)');
      } else if (response.status === 500) {
        // console.log('❌ Server Error (500)');
        dispatch(updateAiAdminWorkspaceConfiguration(formData));
      } else {
        // console.log(`⚠️ Received unexpected status: ${response.status}`);
      }

      dispatch(hideCommonLoader()); // ✅ Hide loader after response

      return response.data;
    } catch (error) {
      // console.error('Axios Error:', error);

      if (error.response) {
        const status = error.response.status;
        // console.error(`Error Status: ${status}`);

        if (status === 500) {
          dispatch(updateAiAdminWorkspaceConfiguration(formData)); // ✅ Use original formData here
        }
      }

      dispatch(hideCommonLoader()); // ✅ Always hide loader on error
    }
  };
};

export const updateAiAdminWorkspaceConfiguration = (formData) => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    const aiPayload = {
      workspace: formData.workspaceLabel,
      llm: formData.llm_model,
      k_value: formData.allowed_excel_rows,
      persona: formData.persona || "",
      rules: formData.rules || "",
      instructions: formData.instructions || "",
    };

    let persona = "";
    let rules = "";
    let instructions = "";

    try {
      const verifyData = JSON.parse(formData.verifyData);
      persona = verifyData.persona || "";
      rules = verifyData.rules || "";
      instructions = verifyData.instruction || "";
    } catch (e) {
      // fallback if verifyData is not a valid JSON string
      persona = formData.persona || "";
      rules = formData.rules || "";
      instructions = formData.instructions || "";
    }

    // Do not discard llm and k (llm_model and allowed_excel_rows)
    aiPayload.persona = persona;
    aiPayload.rules = rules;
    aiPayload.instructions = instructions;
    aiPayload.llm = formData.llm_model || aiPayload.llm;
    aiPayload.k_value = formData.allowed_excel_rows || aiPayload.k_value;
    try {
      dispatch(showCommonLoader());

      const response = await axios(
        GYPSYBALL_PYTHON_API_URL +
          "workspace-config/" +
          formData.workspaceLabel,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          data: aiPayload,
        }
      );

      dispatch(hideCommonLoader());
      // console.log("AI API success:", response.data);
      // Optionally: dispatch a success action here
    } catch (error) {
      dispatch(hideCommonLoader());
      // console.error("AI API error:", error);
      // Optionally: dispatch a failure action here
    }
  };
};

export const sessionAdminStop = (data) => async (dispatch) => {
  var token = localStorage.getItem("token");

  dispatch(workspaceAdminRequest());
  dispatch(showCommonLoader());

  try {
    const response = await axios.post(
      GYPSYBALL_PYTHON_API_URL + "session/stop",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
        },
      }
    );

    // Process response if needed

    // Hide loader only after successful response
    dispatch(hideCommonLoader());

    // Uncomment this line if workspace update success handling is needed
    // workspaceAdminAddUpadteSuccess('Workspace Configuration Done Successfully', 'create', dispatch);
  } catch (error) {
    // console.error('Error:', error);
    dispatch(hideCommonLoader());
    handleErrorResponse(error, dispatch);
  }
};

export const workspaceAdminExposure = (data) => {
  const token = localStorage.getItem("token");
  const workspace_id = data.id;
  const workspace = data.name;
  const toggle = data.isExposed;

  return async (dispatch) => {
    dispatch(workspaceAdminRequest());
    dispatch(showCommonLoader());

    try {
      // First API call to Gypsyball Python API
      const gypsyballResponse = await axios(
        GYPSYBALL_PYTHON_API_URL + "toggle",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          data: {
            workspace,
            toggle,
          },
        }
      );

      const response_url = gypsyballResponse.data?.response_url;

      if (!response_url) {
        throw new Error("Gypsyball API did not return a response_url");
      }

      dispatch(workspaceAdminRequest());
      dispatch(showCommonLoader());
      // Second API call to the local API
      const workspaceApiResponse = await axios(
        API_URL + "workspace/workspaceAdminExposure/" + workspace_id,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
          data: {
            workspace,
            toggle,
            response_url,
          },
        }
      );

      // Return the final response data
      return {
        gypsyballData: gypsyballResponse.data,
        workspaceApiData: workspaceApiResponse.data,
      };
    } catch (error) {
      handleErrorResponse(error, dispatch);
      throw error; // Re-throw the error for handling in the calling component
    } finally {
      dispatch(hideCommonLoader());
      // workspaceAdminAddUpadteSuccess('Workspace Exposure Done Successfully','create',dispatch);
    }
  };
};
